import { DialogTitle, DialogContent, DialogActions, Dialog, Typography, Button } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "@privacy/translations";

type UserResponsibleWarningDialogProps = {
  onClose: () => void;
};

export const UserResponsibleWarningDialog: FC<UserResponsibleWarningDialogProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog slotProps={{ paper: { sx: { maxWidth: "30rem" } } }} open onClose={onClose}>
      <DialogTitle>{t("UserSetting.UpdateRole.ResponsibleDialogHeader")}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{t("UserSetting.UpdateRole.ResponsibleDialogMessage")}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("UserSetting.UpdateRole.ResponsibleDialogButton")}</Button>
      </DialogActions>
    </Dialog>
  );
};
